import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function EditEndDate({ show, onHide, data, submitClick }) {
  const [val, setVal] = useState("");
  function handleShow() {
    setVal("");
  }
  return (
    <>
      {/* {console.log("endDate:", data)} */}
      <Modal show={show} onShow={handleShow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Edit Training End Date</h5>
        </ModalHeader>
        <ModalBody>
          <input type="date" onChange={(e) => setVal(e.target.value)} className="form-control" aria-describedby="Title Edit" />
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submitClick({ id: data.id, label: "endDate", val: val })} type="button" className="btn btn-outline-theme" disabled={val ? false : true}>
            Save
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default EditEndDate;
